<template>
  <div>
    <CommHeader />
    <CommSwipe :dataList="swipeDataList" />
    <div class="text-center common-margin font-14">
      待更新......
    </div>
    <CommBrand />
    <CommFooter />
  </div>
</template>

<script>
import CommHeader from '@/components/CommHeader'
import CommSwipe from '@/components/CommSwipe'
import CommBrand from '@/components/CommBrand'
import CommFooter from '@/components/CommFooter'
export default {
  name: 'home',
  components: {
    CommHeader,
    CommSwipe,
    CommBrand,
    CommFooter
  },
  data () {
    return {
      swipeDataList: [{img: require('images/home/sw-img1.jpg'),
        caption: '高铁运营',
        url: '#',
        describe: ''
      }]
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/product/Gt.vue